import { SETPOSITION, FIELDVALUETYPES } from './types/field.index.types'

export const initialFieldValue: FIELDVALUETYPES = {
    size: 35,
    position: {
      x: 17,
      y: 17,
    }
}

export const initialFields = (fieldSize: number, snakePosition: SETPOSITION): Array<string[]> => {
  const fields: Array<string[]> = generateFields(fieldSize);
  const foodPosition = generateFoodPosition(fieldSize, snakePosition);
  
  fields[snakePosition.y][snakePosition.x] = 'snake';
  fields[foodPosition.y][foodPosition.x] = 'food';

  return fields;
}

const generateFields = (fieldSize: number): Array<string[]> => {
  const fields: Array<string[]> = [];
  for (let i = 0; i < fieldSize; i++) {
      const cols = new Array<string>(fieldSize).fill('');
      fields.push(cols);
  }
  return fields;
}

export const generateFoodPosition = (fieldSize: number, excludes: SETPOSITION): SETPOSITION => {
  while (true) {
    const x = Math.floor(Math.random() * ((fieldSize - 1) - 1)) + 1;
    const y = Math.floor(Math.random() * ((fieldSize - 1) - 1)) + 1;
    const conflict: boolean = excludes.x === x && excludes.y === y;

    if (!conflict) {
      return { x, y };
    }
  }
};